export default "__VITE_ASSET__Czlj8KyF__"